import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown,
  faCaretUp,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faMinusSquare,
  faPlusCircle,
  faPlusSquare,
  faSearch,
  faSort,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AsyncComputed from 'vue-async-computed';
import VueMaterial from 'vue-material';
import VeeValidate from 'vee-validate';
import App from './App.vue';
import router from './router';
import store from './store';
import ability from './ability';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import i18n from '@/plugins/i18n';

const UserRepository = RepositoryFactory.get('users');
const GroupsRepository = RepositoryFactory.get('groups');
const SalonsRepository = RepositoryFactory.get('salons');
const DevicesRepository = RepositoryFactory.get('devices');
const ConfigurationRepository = RepositoryFactory.get('configuration');

Vue.config.productionTip = false;
library.add(faChevronUp);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faPlusCircle);
library.add(faSort);
library.add(faCaretDown);
library.add(faCaretUp);
library.add(faSearch);
library.add(faPlusSquare);
library.add(faMinusSquare);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(abilitiesPlugin, ability);
Vue.use(AsyncComputed);
Vue.use(VueMaterial);
Vue.use(VeeValidate, {
  classes: true,
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
